import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import './_commonjsHelpers-ba3f0406.js';

const pesCtaButtonCss = ":host{display:inline}.cta-button__content{display:inline-flex;align-items:center;max-width:100%}.cta-button__icon{padding:0}:host(:not([dir=\"rtl\"])) .cta-button__icon:first-child{padding-right:6px}:host([dir=\"rtl\"]) .cta-button__icon:first-child{padding-left:6px}:host(:not([dir=\"rtl\"])) .cta-button__icon:last-child{padding-left:6px}:host([dir=\"rtl\"]) .cta-button__icon:last-child{padding-right:6px}.cta-button__text{overflow:hidden;text-overflow:ellipsis}.cta-button__bundle .cta-button__content{white-space:normal}";

let PesCtaButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didClick = createEvent(this, "didClick", 7);
    this.type = 'primary';
    this.size = 'medium';
    this.iconPosition = 'start';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderIcon(icon, position) {
    const size = position === 'end' ? 'micro' : 'small';
    return icon ? (h("pes-icon", { class: "cta-button__icon", size: size }, icon)) : null;
  }
  render() {
    return (h("se-button", { block: true, padding: "none", size: this.size, class: classnames('cta-button', this.extraClass), color: "secondary", option: this.type === 'secondary' ? 'outline' : 'flat', onClick: (e) => this.didClick.emit(e) }, h("span", { class: "cta-button__content" }, this.iconPosition === 'start' && this.renderIcon(this.icon, this.iconPosition), h("span", { class: "cta-button__text" }, h("slot", null)), this.iconPosition === 'end' && this.renderIcon(this.icon, this.iconPosition))));
  }
  get el() { return getElement(this); }
};
PesCtaButton.style = pesCtaButtonCss;

export { PesCtaButton as pes_cta_button };
